import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Button, Message } from '@verclam/ui-kit';

const stackStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

const messageContentStyle = css`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem 0.75rem;
`;

type Props = {
	/** The document is verified and the draft would reopen it. */
	readonly isReopenWarningShown: boolean;
	/** The server's `message` of the last failed submission. */
	readonly errorMessage: string | null;
	readonly onRetry: () => void;
	/** The outcome of the last submission. */
	readonly notice: string | null;
	/** Reveals the first passage that appeared; `null` when none did. */
	readonly onReveal: (() => void) | null;
};

/** The panel's messages, above the actions: prevention before saving, failure with its retry, outcome with its "Voir". */
const FieldPanelMessages: React.FC<Props> = ({
	isReopenWarningShown,
	errorMessage,
	onRetry,
	notice,
	onReveal,
}) => {
	return (
		<div css={stackStyle}>
			<ConditionalLoader data={isReopenWarningShown}>
				<Message
					severity="warn"
					role="status"
					text="Ce document est vérifié : enregistrer cette modification le repassera en cours de vérification."
				/>
			</ConditionalLoader>
			<ConditionalLoader data={errorMessage}>
				{(message) => (
					<Message
						severity="error"
						content={
							<div css={messageContentStyle}>
								<span>{message}</span>
								<Button
									type="button"
									size="sm"
									severity="danger"
									outlined
									label="Réessayer"
									onClick={onRetry}
								/>
							</div>
						}
					/>
				)}
			</ConditionalLoader>
			<ConditionalLoader data={notice}>
				{(text) => (
					<Message
						severity="success"
						role="status"
						content={
							<div css={messageContentStyle}>
								<span>{text}</span>
								<ConditionalLoader data={onReveal}>
									{(reveal) => (
										<Button type="button" size="sm" link label="Voir" onClick={reveal} />
									)}
								</ConditionalLoader>
							</div>
						}
					/>
				)}
			</ConditionalLoader>
		</div>
	);
};

export default FieldPanelMessages;
